import React from 'react'

const ReturnHandling = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={40}
                height={40}
                x={0}
                y={0}
                viewBox="0 0 500 500"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <g fillRule="evenodd" clipRule="evenodd">
                        <path
                            fill="#d6b4a8"
                            d="m271.332 88.013 88.094 50.861-88.094 50.861-88.095-50.861z"
                            opacity={1}
                            data-original="#d6b4a8"
                        />
                        <path
                            fill="#c89d8d"
                            d="m183.237 240.596 88.095 50.862V189.735l-88.095-50.861z"
                            opacity={1}
                            data-original="#c89d8d"
                            className="hovered-path"
                        />
                        <path
                            fill="#a37767"
                            d="M271.332 189.735v101.723l88.094-50.862V138.874z"
                            opacity={1}
                            data-original="#a37767"
                        />
                        <path
                            fill="#e33f65"
                            d="M327.038 217.709v-60.136l-88.094-50.861-23.319 13.463 88.094 50.861v60.136z"
                            opacity={1}
                            data-original="#e33f65"
                        />
                        <path
                            fill="#847784"
                            d="M144.413 72.579c77.581-64.745 194.106-49.298 251.931 33.891 25.161 36.197 36.511 82.008 28.086 128.851a6.505 6.505 0 0 1-12.806-2.295c7.784-43.276-2.72-85.624-25.994-119.106-53.513-76.988-161.07-91.078-232.714-31.494l20.376 3.304a6.509 6.509 0 0 1-2.04 12.856l-39.493-6.404c-4.328-.694-6.511-4.926-4.929-9.297l-.003-.001L140.23 45.9a6.512 6.512 0 0 1 12.244 4.438z"
                            opacity={1}
                            data-original="#847784"
                        />
                        <path
                            fill="#f0b16e"
                            d="M111.025 375.785c30.621-26.418 57.257-57.144 101.055-57.304l88.089-.348c18.195-.279 17.83 22.488 10.252 28.827-2.508 2.098-5.533 3.323-7.608 3.346l-46.335.42a5.37 5.37 0 0 0 .084 10.738l53.072-.421c1.159-.013 15.866-5.345 32.823-20.168l63.782-55.757c14.979-3.506 21.97 10.976 12.545 23.628l-78.844 80.787c-1.77 2.449-4.259 4.001-7.151 5.048-3.988 1.284-8.211 1.941-12.62 2.103l-98.209 4.207c-7.815.295-12.203 4.728-17.773 8.098l-49.835 27.371z"
                            opacity={1}
                            data-original="#f0b16e"
                        />
                        <path
                            fill="#847784"
                            d="m130.501 352.116 51.505 70.052c3.581 4.872 2.526 11.788-2.345 15.37l-37.844 27.824c-4.872 3.581-11.788 2.526-15.369-2.345l-51.504-70.052c-3.583-4.871-2.527-11.788 2.345-15.369l37.844-27.825c4.87-3.582 11.786-2.527 15.368 2.345z"
                            opacity={1}
                            data-original="#847784"
                        />
                    </g>
                </g>
            </svg>

        </>
    )
}

export default ReturnHandling